<template>
    <div class="text-center" v-if="true">
        <BlockUI>
            <div class="loader"></div>
        </BlockUI>
    </div>
</template>

<script>
import { loginByAuth0 } from "@/axios/login"

export default {
    async mounted() {
        try {
            if (
                window.location.search.includes('code=') &&
                window.location.search.includes('state=')
            ) {

                await this.$auth0.handleRedirectCallback();
                loginByAuth0().then( res => {
                    if(res.success === '1'){
                        const url = new URL('/transports', window.location.origin)
                        window.location.href = url.toString()
                    }
                })
            }
        } catch (err) {
            console.log(`handleRedirectCallback:: ${err}`);
        }
    },
}
</script>